import script from "./Payments.vue?vue&type=script&setup=true&lang=ts"
export * from "./Payments.vue?vue&type=script&setup=true&lang=ts"

import "./Payments.vue?vue&type=style&index=0&id=dce3fb5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dce3fb5e"]])

export default __exports__